'use strict'

const { SerializerSelector, StandaloneSerializer } = require('./standalone')

module.exports = SerializerSelector
module.exports.default = SerializerSelector
module.exports.SerializerSelector = SerializerSelector
module.exports.StandaloneSerializer = StandaloneSerializer
